import { BehaviorSubject } from "rxjs";

const disabledBtnTurn$ = new BehaviorSubject(false);
export const getDisabledBtnTurn = () => disabledBtnTurn$.asObservable();
export const setDisabledBtnTurn = (value) => disabledBtnTurn$.next(value);

const idArrDisabled$ = new BehaviorSubject([]);
export const getIdArrDisabled = () => idArrDisabled$.asObservable();